import { render, staticRenderFns } from "./AssignValidatorsPanel.vue?vue&type=template&id=57ee62d4&scoped=true&"
import script from "./AssignValidatorsPanel.vue?vue&type=script&lang=js&"
export * from "./AssignValidatorsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AssignValidatorsPanel.vue?vue&type=style&index=0&id=57ee62d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ee62d4",
  null
  
)

export default component.exports